'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareQuery = exports.parseQuery = exports.prepareQueryString = exports.parseArray = exports.arrayBrackets = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _isFunction = require('../validators/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isArray = require('../validators/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = require('../validators/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isDefined = require('../validators/isDefined');

var _isDefined2 = _interopRequireDefault(_isDefined);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * @description :: Determinating wich format should an array query have
 * @param {String} format :: The format to append
 * @param {Number} index :: The array index of the value
 * @return {String} :: Formatted array query key
 */
// Validators


var arrayBrackets = exports.arrayBrackets = function arrayBrackets(format, index) {
  switch (format) {
    case 'brackets':
      {
        return '[]';
      }

    case 'index':
      {
        return '[' + index + ']';
      }

    default:
      {
        return '';
      }
  }
};
/**
 * @description :: Parsing the array query
 * @param {String} key :: The query key
 * @param {any} value :: The query value
 * @param {String} seperator :: key value seperator
 * @param {String} format :: The format for the array query key
 * @return {String} :: Formatted array query
 */


var parseArray = exports.parseArray = function parseArray(_ref) {
  var key = _ref.key,
      value = _ref.value,
      _ref$seperator = _ref.seperator,
      seperator = _ref$seperator === undefined ? '=' : _ref$seperator,
      _ref$format = _ref.format,
      format = _ref$format === undefined ? 'none' : _ref$format;
  return value.map(function (val, index) {
    return '' + key + arrayBrackets(format, index) + seperator + val;
  }).join('&');
};
/**
 * @description :: Transforming the query to a query string
 * @param {String} key :: The key of the query
 * @param {any} value :: the query value
 * @return {String} :: Stringified query
 */


var prepareQueryString = exports.prepareQueryString = function prepareQueryString(key, value) {
  if ((0, _isArray2.default)(value)) return parseArray({
    key: key,
    value: value
  });

  if ((0, _isObject2.default)(value) && (0, _isDefined2.default)(value.value)) {
    var seperator = value.seperator ? value.seperator : '=';

    if ((0, _isArray2.default)(value.value)) {
      value.key = key;
      return parseArray(value);
    }

    return '' + key + seperator + value.value;
  }

  return key + '=' + value;
};
/**
 * @description :: Parsing the query
 * @param {any} _query :: The query to parse
 * @return {String} :: Stringified query
 */


var parseQuery = exports.parseQuery = function parseQuery(_query) {
  var query = (0, _isFunction2.default)(_query) ? _query() : _query;
  return !(0, _isObject2.default)(query) ? '' + query : (0, _keys2.default)(query).map(function (queryKey) {
    return prepareQueryString(queryKey, query[queryKey]);
  }).join('&');
};
/**
 * @description :: Stringifying the query for fetch execution
 * @param {Array} queries :: Array of queries
 * @description {String} :: Stringified query
 */


var prepareQuery = exports.prepareQuery = function prepareQuery() {
  for (var _len = arguments.length, queries = Array(_len), _key = 0; _key < _len; _key++) {
    queries[_key] = arguments[_key];
  }

  var query = queries.map(parseQuery).join('&');
  return '' + (query.length ? '?' : '') + (query.endsWith('&') ? query.slice(0, -1) : query);
};